import { KeyboardArrowRight } from "@mui/icons-material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { useTranslation } from "react-i18next";

import useNavigateTo from "../../hooks/useNavigateTo";
import {
  InboundDeliveryOverviewFragment,
  InboundDeliveryStatus,
} from "../../models/autogenerated-deliveryService-gql/graphql";
import CopyButton from "../buttons/CopyButton";
import CtaSection from "../deliveryCtaSection/DeliveryCtaSection";
import DetailsGeneralInfo from "../deliveryGeneralInfo/DeliveryGeneralInfo";
import OrderHeader from "../orderHeader/OrderHeader";
import "./DeliveryCard.scss";
import AddressSection from "./sections/addressSection/AddressSection";

interface DeliveryCardProps {
  delivery: InboundDeliveryOverviewFragment;
}

export default function DeliveryCard(props: DeliveryCardProps) {
  const { t } = useTranslation();
  const { navigateToDeliveryDetails } = useNavigateTo();
  const { delivery } = props;
  const { id, deliveryNumber, status, numberOfItems } = delivery;

  const shouldApplySecondaryColoring =
    status === InboundDeliveryStatus.Completed;

  const dividerClassName = `${"page-content-divider"} ${
    shouldApplySecondaryColoring ? "bright-border" : ""
  }`;

  const cardClassName = shouldApplySecondaryColoring
    ? "card-conditional-background-color"
    : "";

  return (
    <div data-testid="card-list-item" className="card-list-item">
      <div data-testid={id} className="card-list-item-card done">
        <Card
          variant="outlined"
          data-testid={"deliveryCard" + id}
          className={cardClassName}
        >
          <CardContent>
            <OrderHeader status={status} amount={numberOfItems} />
            <div className={dividerClassName} />
            <div className="id-row">
              <div>{`${t("deliveryNumber")}: ${deliveryNumber}`}</div>
              <div className="id-row-copy">
                <CopyButton tooltip={"Copy ID"} value={id} />
              </div>
            </div>
            <DetailsGeneralInfo
              delivery={delivery}
              showActions={false}
              showLocation={false}
              secondaryColoring={status === InboundDeliveryStatus.Completed}
            />
            <CtaSection actions={delivery.actions} deliveryId={id} />
            <AddressSection delivery={delivery} />
          </CardContent>
        </Card>
      </div>
      <div className="card-list-item-button">
        <KeyboardArrowRight onClick={() => navigateToDeliveryDetails(id)} />
      </div>
    </div>
  );
}
